import React from "react";
import UserHandler from "js/utilities/user-handler";
import { Link } from "react-router";

export default React.createClass({
  displayName: "get-display-apptoken",

  getInitialState: function() {
    return {appToken : null};
  },
  buildLine: function() {
    if (!this.state.appToken) {
      if (this.props.link) {
        return <Link className={this.props.className} to={this.props.link}> {this.props.prompt}</Link>
      }
      else {
        return this.props.prompt;
      }
    }
    else {
      return this.state.appToken;
    }
  },

  render: function() {

    return (
      <span >
        {this.buildLine()}
      </span>
    )
  }
});



// WEBPACK FOOTER //
// ./src/js/utilities/get-display-apptoken.jsx